import type { CustomerPrivacyDashboard } from '../customerPrivacyApi'
import { usePrivacyDashboardState } from './privacy/usePrivacyDashboardState'
import { usePrivacyOperations } from './privacy/usePrivacyOperations'

type UseCustomerPrivacyInput = {
  authenticated: boolean
  shouldLoadPrivacyDashboard: boolean
}

type UseCustomerPrivacyResult = {
  privacyDashboard: CustomerPrivacyDashboard | null
  privacyLoading: boolean
  privacyError: string
  privacyRefreshing: boolean
  exportRequesting: boolean
  exportDownloading: boolean
  consentsSaving: boolean
  deletionSubmitting: boolean
  privacyNotice: string
  refreshPrivacyDashboard: () => void
  requestPrivacyExport: () => void
  downloadPrivacyExport: () => void
  updatePrivacyConsents: (input: {
    marketingEmail: boolean
    promotionalNotifications: boolean
  }) => void
  requestAccountDeletion: (password: string) => void
}

export const useCustomerPrivacy = ({
  authenticated,
  shouldLoadPrivacyDashboard,
}: UseCustomerPrivacyInput): UseCustomerPrivacyResult => {
  const canLoad = authenticated && shouldLoadPrivacyDashboard

  const {
    privacyDashboard,
    privacyLoading,
    privacyRefreshing,
    privacyError,
    setPrivacyError,
    privacyNotice,
    setPrivacyNotice,
    loadDashboard,
    refreshPrivacyDashboard,
  } = usePrivacyDashboardState({
    canLoad,
  })

  const {
    exportRequesting,
    exportDownloading,
    consentsSaving,
    deletionSubmitting,
    requestPrivacyExport,
    downloadPrivacyExport,
    updatePrivacyConsents,
    requestAccountDeletion,
  } = usePrivacyOperations({
    privacyDashboard,
    loadDashboard,
    setPrivacyError,
    setPrivacyNotice,
  })

  return {
    privacyDashboard,
    privacyLoading,
    privacyError,
    privacyRefreshing,
    exportRequesting,
    exportDownloading,
    consentsSaving,
    deletionSubmitting,
    privacyNotice,
    refreshPrivacyDashboard,
    requestPrivacyExport,
    downloadPrivacyExport,
    updatePrivacyConsents,
    requestAccountDeletion,
  }
}
